import React, {useEffect, useState} from 'react';
import {ReactSVG} from 'react-svg';

// import {fax_phone, mail, mobile_phone, telegram, viber, whatsapp} from '../../assets';
import {ContactsModal, CubeSwiper, Header, Menu} from '../../components';
import {MENU_ITEMS, RAILWAY_CARRIAGE_ITEMS, SWIPER_ITEMS_P3, SWIPER_ITEMS_P5} from '../../const';

import './style.scss';

const General = props => {
	const [isOpenMenu, setIsOpenMenu] = useState(false);
	const [isOpenContacts, setIsOpenContacts] = useState(false);
	const {hash} = window.location;

	const p4Items = RAILWAY_CARRIAGE_ITEMS.map(item => {
		return (
			<div key={item.type} className="railway_carriage_item">
				<h3>{item.title}</h3>
				<div className="p4-container">
					<ReactSVG src={item.src} className="p4-container__img" />
					<div className="p4-container__description">{item.description}</div>
				</div>
			</div>
		);
	});

	useEffect(() => {
		if (hash) {
			const link = document.createElement('a');
			link.href = `${hash}`;
			setTimeout(() => link.click(), 0);
		}
	}, [hash]);

	return (
		<div className="ct" id="t2">
			<div className="ct" id="t3">
				<div className="ct" id="t4">
					<div className="ct" id="t5">
						<div className="ct" id="t6">
							<Menu
								navItems={MENU_ITEMS}
								isOpenMenu={isOpenMenu}
								menuHandler={setIsOpenMenu}
							/>
							<Header
								isOpenMenu={isOpenMenu}
								menuHandler={setIsOpenMenu}
								isOpenContacts={isOpenContacts}
								setIsOpenContacts={setIsOpenContacts}
							/>
							<ContactsModal isOpenContacts={isOpenContacts} />
							<div className={`page ${isOpenMenu ? 'open' : ''}`} id="p1">
								<section className="main">
									<h2 className="title">
										Организация и расчет стоимости перевозки грузов по железным
										дорогам Республики Беларусь, стран СНГ и Балтии.
									</h2>
									<p className="general-page">
										Организация перевозки грузов представляет собой сложный
										комплекс мероприятий с момента отправления и до момента
										прибытия груза по назначению, включающий разработку
										оптимального маршрута, расчет стоимости доставки, подготовку
										всей необходимой документации на груз, определение
										транспортных и погрузочных средств, необходимых для данного
										груза.
									</p>
									<p className="general-page">
										Мы готовы рассчитать варианты доставки вашей продукции
										железной дорогой, что может послужить альтернативой
										существующей у вас автомобильной доставке и положительно
										отразиться на финансовых показателях вашего предприятия.
									</p>
									<p className="general-page">
										Вместе с тем, можем организовать международные перевозки
										грузов в контейнерах по морю, включая любые сопроводительные
										операции в портах России по импорту, экспорту, реэкспорту,
										реимпорту и экспедированию груза (комплекс работ, связанный
										с сопровождением или обработкой груза в порту прибытия c
										обязательным проведением всех необходимых процедур,
										оформлением документов при взаимодействии с официальными
										государственными и портовыми службами).
									</p>
								</section>
							</div>
							<div className={`page ${isOpenMenu ? 'open' : ''}`} id="p2">
								<section className="main">
									<h2 className="title">
										Выполнение функций грузоотправителя (грузополучателя) при
										отправлении (получении) груза на железнодорожной станции.
									</h2>
									<h3>Функции грузоотправителя включают:</h3>
									<div className="list">
										<p>
											подбор ближайшей железнодорожной станции и площадки, с
											учетом необходимых условий для погрузки груза;
										</p>
										<p>
											подача заявки на перевозку ГУ-12 в АС «Электронная
											перевозка»;
										</p>
										<p>предоставление вагона (контейнера) под погрузку;</p>
										<p>разработка и согласование эскизов и чертежей, МТУ;</p>
										<p>оплата железнодорожных тарифов и станционных сборов;</p>
										<p>
											организация погрузочно-разгрузочных работ и крепления
											груза в вагоне (контейнере);
										</p>
										<p>таможенное оформление груза;</p>
										<p>
											оформление перевозочных документов на отправку груза, в
											том числе в АС «Электронная перевозка» и передача груза
											в вагоне (контейнере) перевозчику;
										</p>
										<p>
											оформление перевозочных документов на порожние вагоны
											(контейнера) в АС «Электронная перевозка».
										</p>
									</div>
									<h3>Функции грузополучателя включают:</h3>
									<div className="list">
										<p>
											подбор ближайшей железнодорожной станции и площадки, с
											учетом необходимых условий для выгрузки груза;
										</p>
										<p>оплата железнодорожного тарифа и станционных сборов;</p>
										<p>растамаживание груза;</p>
										<p>
											раскредитование перевозочных документов на груз,
											порожние вагоны, в том числе в АС «Электронная
											перевозка»;
										</p>
										<p>
											организация погрузочно-разгрузочных работ и проверка
											состояния груза;
										</p>
										<p>размещение груза на складе;</p>
										<p>
											доставка груза автотранспортом до склада конечного
											получателя.
										</p>
									</div>
								</section>
							</div>
							<div className={`page ${isOpenMenu ? 'open' : ''}`} id="p3">
								<section className="main">
									<h2 className="title">
										Размещение и крепление оборудования и техники, негабаритных
										грузов на открытом железнодорожном подвижном составе.
									</h2>
									<p>
										Для обеспечения качественного размещения и крепления грузов
										на открытом подвижном составе, а также соблюдения требований
										их безопасной перевозки по железной дороге, необходимы
										многолетний опыт и квалификация в области погрузки и
										крепления грузов.
									</p>
									<p>
										Специалисты нашей компании проведут работы по размещению и
										креплению вашего груза в вагоне, согласно предоставленных
										схем и чертежей. Руководство работами осуществляется
										специалистами, имеющими большой опыт в креплении грузов в
										вагонах и соответствующее удостоверение о проверке знаний в
										ОАО «Белорусская железная дорога».
									</p>
									<p>
										По вашей заявке организуем разработку и согласование схем
										размещения и крепления вашей продукции на железнодорожном
										подвижном составе.
									</p>
									<CubeSwiper items={SWIPER_ITEMS_P3} />
								</section>
							</div>
							<div className={`page ${isOpenMenu ? 'open' : ''}`} id="p4">
								<section className="main">
									<h2 className="title">
										Предоставление вагонов и контейнеров (в том числе морских
										линий) под перевозки.
									</h2>
									<p>
										Наши сотрудники подберут вагон (контейнер), с учетом свойств
										и параметров вашей продукции и предоставят на станцию
										погрузки в заявленные вами сроки.
									</p>
									<p>
										При необходимости, готовы организовать текущие и плановые
										виды ремонта, устранение иных неисправностей грузовых
										вагонов на территории Республики Беларусь, а также поставим
										на слежение ваши вагоны, с предоставлением оперативной
										дислокации.
									</p>
									{p4Items}
								</section>
							</div>
							<div className={`page ${isOpenMenu ? 'open' : ''}`} id="p5">
								<section className="main">
									<h2 className="title">
										Организация погрузочно-разгрузочных работ на станциях
										Белорусской железной дороги, стран СНГ и Балтии.
									</h2>
									<p>
										Железнодорожные перевозки грузов сопровождаются
										многочисленными грузовыми операциями. От быстроты и качества
										их выполнения в значительной степени зависит соблюдение
										сроков доставки сырья и продукции потребителям.
									</p>
									<p>
										По вашему запросу наши сотрудники подберут ближайшую
										железнодорожную станцию и площадку, с учетом необходимых
										условий для погрузки/выгрузки/перегрузки вашей продукции, а
										также организуют погрузочно - разгрузочные работы на
										терминалах и подъездных путях станций.
									</p>
									<CubeSwiper items={SWIPER_ITEMS_P5} />
								</section>
							</div>
							<div className={`page ${isOpenMenu ? 'open' : ''}`} id="p6">
								<section className="main">
									<h2 className="title">
										Консультирование по вопросам осуществления железнодорожных
										перевозок грузов.
									</h2>
									<p>
										Железная дорога представляет собой крупный комплекс с
										развитой инфраструктурой для оказания транспортных услуг.
										Вместе с тем, организация перевозок грузов железнодорожным
										транспортом имеет свою специфику, требующую специальных
										знаний и опыта.
									</p>
									<p>
										Специалисты нашей компании имеют большой опыт работы в
										транспортной сфере, знают регламент и нюансы работы железной
										дороги, благодаря чему, на профессиональном уровне
										сопроводят вас на всем этапе совершения перевозки, начиная с
										разъяснения грузовладельцу его статуса в перевозке,
										обязанностей и рисков, помогут в оформлении перевозочных и
										иных документов на станции отправления (получения), в том
										числе посредством АС «Электронная перевозка».
									</p>
									<p>
										Кроме того, в нашей компании можно получить
										квалифицированную юридическую помощь и сопровождение по
										вопросам, возникающим в процессе организации железнодорожных
										перевозок в рамках законодательства РБ и РФ, в том числе в
										отношениях с перевозчиком (снижение суммы штрафов,
										правомерность начисления тарифов и т.п.) в целях обеспечения
										финансовых интересов вашей компании.
									</p>
								</section>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default General;
